/**
 * @city_search
 * @constructor
 */
import { Timeout } from '../common/const';
import {findAncestorByAttr, findAncestorByClassname} from '../common/utils';

let scrollbar = null;

// поместить город в куки
function setCookie(data) {
    $.cookie(`user-city`, data);
}

// подставить выбранный город
function setResultCityContent(city) {
    const resultBlocks = document.querySelectorAll(`[data-city-res]`);

    resultBlocks.forEach(block => {
        block.textContent = city;
        block.style.display = ``;
    });
}

// получить все города модалки
function getAllCities(btns) {
    let arr = [];

    btns.forEach(btn => {
        arr.push(btn.getAttribute(`data-city-value`).replaceAll(` `, ``).toLowerCase());
    });
    return arr;
}

// добавить скроллбар на выпадающий список, если его нет
function addScrollbar(list) {
    if (!list) return;
    if (!scrollbar) {
        scrollbar = new window.SimpleBar(list, { autoHide: false });
    } else {
        recalculateScrollbar();
    }
}

function recalculateScrollbar() {
    if (scrollbar) scrollbar.recalculate();
}

export const initCitySearch = () => {
    document.addEventListener(`click`, e => {
        const target = e.target;
        const wrap = findAncestorByAttr(target, `data-search-wrap`);

        // выбор города
        if (target === target.closest(`[data-city-value]`)) {
            if (!wrap) return;

            const attr = target.getAttribute(`data-city-value`);
            const btns = wrap.querySelectorAll(`[data-city-value]`);
            const input = wrap.querySelector(`[data-city-input]`);

            // выбор города в дропдауне
            if (findAncestorByAttr(target, `data-toggle-container`)) {
                // ЗАКОММЕНТИРОВАНО ПОТОМУ ЧТО НАДО, НЕ ВОЗВРАЩАТЬ!
                // const toggleBtn = findAncestorByAttr(input, `data-toggle-btn`);
                // toggleBtn.dispatchEvent(new CustomEvent(`click`, {
                //     bubbles: true,
                //     cancelable: false
                // }));
            }
            // выбор города в модалке
            else if (findAncestorByClassname(target, `modal`)) {
                setCookie(attr);
                $.fancybox.close();
            }

            setResultCityContent(attr);
            input.value = attr;
            // setTimeout(() => {
            //     const input = wrap.querySelector(`[data-city-input]`);
            //     input.value = attr;
            //     input.dispatchEvent(new CustomEvent(`input`, {
            //         bubbles: true,
            //         cancelable: false
            //     }));
            // }, Timeout.ANIMATION_TOGGLE);

            btns.forEach(btn => btn.classList.remove(`active`));
            target.classList.add(`active`);

        } else if (target === target.closest(`[data-city-confirm]`)) { // согласие в попапе выбора города
            const popup = findAncestorByAttr(target, `data-popup`);
            const city = popup?.querySelector(`[data-city-res]`);
            setCookie(city);
            $(popup).fadeOut(Timeout.FADE);
        }
    });

    // убирает валидацию при вводе
    // document.addEventListener(`keyup`, e => {
    //     const target = e.target;
    //     if (target === target.closest(`[data-city-input]`)) {
    //         if (target.value) {
    //             target.parentNode.classList.remove(`error`);
    //         } else {
    //             $(target).valid();
    //         }
    //     }
    // });

    // поиск города в модалке
    document.addEventListener(`input`, e => {
        const target = e.target;

        if (target && target === target.closest(`[data-city-input]`)) {

            const wrap = findAncestorByAttr(target, `data-search-wrap`);
            if (!wrap) return;

            const value = target.value.replaceAll(` `, ``).toLowerCase();
            const regExp = new RegExp(value == `\\` ? `` : value, `gi`);

            const errorBlock = wrap.querySelector(`[data-city-error]`);
            const cityBtns = wrap.querySelectorAll(`[data-city-value]`);
            const cities = getAllCities(cityBtns);

            // показ ошибки, если не найден город при поиске
            if (errorBlock) {
                if (!cities.filter(city => city.indexOf(value) !== -1).length) {
                    errorBlock.style.display = `block`;
                } else {
                    errorBlock.style.display = `none`;
                }
            }

            cityBtns.forEach(btn => {
                const attr = btn.getAttribute(`data-city-value`).toLowerCase();
                let text = btn.textContent;

                if (attr.indexOf(value) === -1) {
                    btn.parentNode.style.display = `none`;
                } else {
                    btn.parentNode.style.display = ``;
                    let span = document.createElement(`span`);
                    span.className = `active-symbol`;
                    btn.appendChild(span);
                    let html = text.replace(regExp, (match) => {
                        span.textContent = match;
                        return span.outerHTML;
                    });

                    btn.innerHTML = html;
                }
            });

            // addScrollbar(list);
        }
    });
};

export const refreshCitySearch = () => {

}
// window.initCitySearch = () => new CitySearch().init();
